import { type FC } from 'react';

import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';
import { HasFeatureFlag } from '@/src/features/integrations/statsig/components/HasFeatureFlag';

import { NavDivider } from './NavDivider';

export const EmployerAdminNavLinks: FC = () => (
  <>
    <HasFeatureFlag.DashboardMetabase>
      <SideNavButton icon={DashboardOutlined} page='dashboard'>
        Dashboard
      </SideNavButton>
    </HasFeatureFlag.DashboardMetabase>
    <NavDivider />
    <SideNavButton icon={PeopleOutlined} page='manage-users'>
      People
    </SideNavButton>
    <SideNavButton
      activePages={[
        'raps',
        'rap-assigned-learners',
        'rap-competencies',
        'rap-plan',
        'rap',
        'rap-program',
        'rap-level',
      ]}
      icon={ReceiptLongOutlined}
      page='raps'
    >
      RAPs
    </SideNavButton>
    <NavDivider />
    <SideNavButton icon={SettingsOutlined} page='settings'>
      Settings
    </SideNavButton>
  </>
);
